<div class="contents-area">
  <div>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">提案ステータス</label>
          <div class="list-input-content">
            <app-code-combo-box #cmb_ProposalStatus id="cmb_ProposalStatus" [subid]="'cmb_ProposalStatus'"
              [codeDiv]="'ctp255'" [labelField]="'codeValueName'" id="cmb_ProposalStatus" [subid]="'cmb_ProposalStatus'"
              [(ngModel)]="kymw6900Model.searchParams.proposalStatus" [forcedEnabledMode]="'true'" [tabindex]="0"
              [blank]="true" width="160"></app-code-combo-box>
          </div>
          <label class="list-input-title">部門名</label>
          <div class="list-input-content">
            <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
              [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true" [(ngModel)]="kymw6900Model.searchParams.classCode"
              (ngModelChange)="eventClassCode_CHANGEHandler()" width="160">
            </app-class-code-combo-box>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">提案者</label>
          <div class="list-input-content">
            <select id="cmb_ProposalUser" [tabindex]="0" forcedEnabledMode="'true'"
              [(ngModel)]="kymw6900Model.searchParams.proposalUserId" style="width:205px"
              [disabled]="kymw6900Model.isClient()">
              <ng-template ngFor let-item [ngForOf]="kymw6900Model.proposalUserList">
                <option value="{{item.AssociatedUserId}}">{{item.AssociatedUserName}}</option>
              </ng-template>
            </select>
          </div>
          <label class="list-input-title">商品担当者</label>
          <div class="list-input-content">
            <select *ngIf="!kymw6900Model.isBuyer()" id="cmb_Buyer" [tabindex]="0" forcedEnabledMode="'true'"
              [(ngModel)]="kymw6900Model.searchParams.buyerId" style="width:205px">
              <ng-template ngFor let-item [ngForOf]="kymw6900Model.buyerList">
                <option value="{{item.UserId}}">{{item.UserNmKanji}}</option>
              </ng-template>
            </select>
            <select *ngIf="kymw6900Model.isBuyer()" id="cmb_Buyer_BuyerMode" disabled style="width:205px">
              <option selected>{{kymw6900Model.buyerName}}</option>
            </select>
          </div>
        </div>

        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">商品・規格名</label>
              <div class="list-input-content">
                <app-text-input id="txti_GoodsNameAndStandardName" [subid]="'txti_GoodsNameAndStandardName'"
                  [fullOnly]="true" [maxChars]="30" [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false"
                  [(ngModel)]="kymw6900Model.searchParams.goodsNameAndStandardName" [forcedEnabledMode]="'true'"
                  width="31rem">
                </app-text-input>
              </div>
            </div>
            <ng-container *ngIf="kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()">
              <div class="column-list">
                <label class="list-input-title">希望受注コード</label>
                <div class="list-input-content">
                  <app-order-text-with-catalog id="cmb_PreferredStartOrderCode" [subid]="'cmb_PreferredStartOrderCode'"
                    [autofocus]="true" [tabindex]="0" [forcedEnabledMode]="'true'" class="deliv-catalog"
                    [(ngModel)]="kymw6900Model.searchParams.preferredStartOrderCode"
                    (onChangedCatalogId)="kymw6900Model.searchParams.preferredDelivCatalogId = $event">
                  </app-order-text-with-catalog>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">希望企画回</label>
                <div class="list-input-content">
                  <app-catalog-text-with-order id="cmb_PreferredStartDelivCatalogId" class="deliv-catalog"
                    [subid]="'cmb_PreferredStartDelivCatalogId'" [autofocus]="true" [tabindex]="0"
                    [forcedEnabledMode]="'true'" [(ngModel)]="kymw6900Model.searchParams.preferredDelivCatalogId"
                    (onChangedOrderCode)="kymw6900Model.searchParams.preferredStartOrderCode = $event">
                  </app-catalog-text-with-order>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input id="txti_PCode" type="text" [(ngModel)]="kymw6900Model.searchParams.pcode" plessInputTextSub
                  [restrict]="'[P0-9]'" [maxlength]="8" [autofocus]="true" forcedEnabledMode="'true'" [tabindex]="0"
                  class="pcode" />
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">マスタ入力表</label>
              <div class="list-input-content">
                <app-code-combo-box #cmb_MasterInputStatus id="cmb_MasterInputStatus" [subid]="'cmb_MasterInputStatus'"
                  [codeDiv]="'ctp267'" [labelField]="'codeValueName'"
                  [(ngModel)]="kymw6900Model.searchParams.masterInputStatus" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [blank]="true" [style.width.rem]="7"></app-code-combo-box>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button [tabindex]="0" class="btn-secondary" (click)="eventSearch_CLICKHandler()">検索</button>
    </div>
    <div class="grid">
      <div class="action-area">
        <app-pager [prevDisabled]="!kymw6900Model.pagenation.btnBackEnabled()"
          [nextDisabled]="!kymw6900Model.pagenation.btnNextEnabled()" [totalNum]="kymw6900Model.pagenation.totalNum"
          [startNum]="kymw6900Model.pagenation.startDispNum" [endNum]="kymw6900Model.pagenation.endDispNum"
          (prevHandler)="eventBack_CLICKHandler()" (nextHandler)="eventNext_CLICKHandler()">
        </app-pager>
      </div>
      <wj-flex-grid #dtg_ProposalList [itemsSource]="kymw6900Model.proposalList" class="space-bottom" [tabindex]="0"
        id="dtg_ProposalList" [headersVisibility]="'Column'" [isReadOnly]="true" [allowSorting]="false"
        [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'">
        <ng-container *ngIf="kymw6900Model.isClient()">
          <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'proposalId'" [header]="' '" [align]="'center'"
            [isReadOnly]="true">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="radio" [value]="cell.item.proposalId"
                [checked]="kymw6900Model.isSelected(cell.item.proposalId)"
                (click)="eventChangePropposalRadio_CLICKHandler(cell.item.proposalId);$event.stopPropagation();"
                [tabindex]="0" />
            </ng-template>
          </wj-flex-grid-column>
        </ng-container>
        <ng-container *ngIf="kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()">
          <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'proposalId'" [header]="' '" [align]="'center'"
            [isReadOnly]="true">
            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
              <input type="checkbox" [checked]="kymw6900Model.isHeaderChecked" class="header-checkbox"
                (click)="eventChangeHeader_CLICKHandler();$event.stopPropagation();" [tabindex]="-1" />
            </ng-template>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [value]="cell.item.proposalId"
                [checked]="kymw6900Model.isSelected(cell.item.proposalId)"
                (click)="eventChangePropposalCheck_CLICKHandler(cell.item.proposalId);$event.stopPropagation();"
                [tabindex]="-1" />
            </ng-template>
          </wj-flex-grid-column>
        </ng-container>
        <wj-flex-grid-column [minWidth]="5" [header]="'提案ステータス'" [width]="100" [binding]="'proposalStatus.name'"
          [isReadOnly]="true"></wj-flex-grid-column>
        <ng-container *ngIf="kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()">
          <wj-flex-grid-column [minWidth]="5" [header]="'帳票出力日'" [width]="100" [binding]="'reportOutputDate'" [isReadOnly]="true">
          </wj-flex-grid-column>
        </ng-container>
        <wj-flex-grid-column [minWidth]="5" [header]="'提案者'" [width]="(kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()) ? 165: 345"
          [binding]="'proposalUser.userName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <ng-container *ngIf="!(kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader())">
          <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="140" [binding]="'classCode'" [isReadOnly]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'商品担当者'" [width]="345" [binding]="'buyer.buyerName'"
            [isReadOnly]="true">
          </wj-flex-grid-column>
        </ng-container>
        <ng-container *ngIf="kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()">
          <wj-flex-grid-column [minWidth]="5" [header]="'商品担当者'" [width]="165" [binding]="'buyer.buyerName'"
            [isReadOnly]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="140" [binding]="'classCode'" [isReadOnly]="true">
          </wj-flex-grid-column>
        </ng-container>
        <ng-container *ngIf="kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()">
          <wj-flex-grid-column [minWidth]="5" [header]="'展開開始希望受注コード'" [width]="170" [binding]="'preferredStartOrderCode'"
            [isReadOnly]="true"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'展開開始希望企画回'" [width]="140"
            [binding]="'preferredStartDelivCatalogId'" [isReadOnly]="true"></wj-flex-grid-column>
        </ng-container>
        <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="90" [binding]="'pcode'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品・規格名'" [width]="(kymw6900Model.isBuyer()||kymw6900Model.isGroupLeader()) ? 385: 485" [binding]="'goodsNameAndStandardName'"
          [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'マスタ入力表'" [width]="101" [binding]="'masterInputStatus'"
          [isReadOnly]="true">
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_Create" class="btn-secondary" [tabindex]="0"
    (click)="eventCreateProposal_CLICKHandler()">新規商品提案</button>
  <button id="btn_Copy" class="btn-secondary" [tabindex]="0"
    (click)="eventCopyProposal_CLICKHandler()">商品提案コピー</button>
  <ng-container *ngIf="kymw6900Model.isBuyer() || kymw6900Model.isGroupLeader()">
    <button class="btn-secondary" [tabindex]="0" (click)="eventOutputProposal_CLICKHandler()">提案商品帳票出力</button>
    <button class="btn-secondary" [tabindex]="0" (click)="eventOutputHandling_CLICKHandler()"
      [style.width.px]="250">新規取扱商品（案）帳票出力</button>
  </ng-container>
  <ng-container *ngIf="kymw6900Model.isBuyer() || kymw6900Model.isGroupLeader()">
    <button id="btn_Reject" class="btn-tartiary" [tabindex]="0"
      (click)="eventRejectProposal_CLICKHandler()">却下</button>
    <button id="btn_Approve" class="btn-primary" [tabindex]="0"
      (click)="eventApproveProposal_CLICKHandler()">承認</button>
  </ng-container>
</footer>